import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import ArrowRightIcon from './ArrowRightIcon';

const ThemedArrowRightIcon = ({ theme, ...props }) => (
    <ArrowRightIcon color={theme.colors['Level 3']} {...props} />
);

ThemedArrowRightIcon.propTypes = {
    theme: PropTypes.shape({}).isRequired,
};

export default withTheme(ThemedArrowRightIcon);
